import React from 'react';
import { Text, View, StyleSheet } from '@react-pdf/renderer';

const styles = StyleSheet.create({
  section: {
    paddingTop: 10,
    paddingBottom: 10,
    paddingRight: 10,
    paddingLeft: 10,
    flexGrow: 1,
    alignItems: 'center',
  },
  section__up: {
    paddingTop: 5,
    paddingBottom: 5,
    paddingRight: 10,
    paddingLeft: 10,
    flexGrow: 1,
  },
  section__down: {
    paddingTop: 0,
    paddingBottom: 5,
    paddingRight: 10,
    paddingLeft: 10,
    flexGrow: 1,
  },
  invoice__date: {
    marginTop: 20,
    marginBottom: 5,
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  invoice__date__Left: {
    borderRadius: '5px',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    backgroundColor: 'rgba(231, 236, 244, .8)',
    width: '100%',
  },
  gray__text: {
    fontSize: 9,
    fontFamily: 'Roboto',
    fontWeight: '400',
  },
  gray__text_up: {
    fontSize: 9,
    fontFamily: 'Roboto',
    fontWeight: '600',
    paddingBottom: 6,
  },
  gray__text__down: {
    fontSize: 9,
    fontFamily: 'Roboto',
    fontWeight: '400',
    paddingTop: 4,
  },
  mr1: {
    width: 37.5 + '%',
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    borderRight: '1px solid #8A9EAF',
    padding: 10,
  },
  mr__l: {
    width: 25 + '%',
    alignItems: 'flex-start',
    padding: 10,
  },
});

export default function MainReport({ customer, vehicle }) {
  const {
    name = '',
    address = '',
    email = '',
    phone = '',
    id = '',
    pstNumber = '',
  } = customer || '';

  const {
    vehicleMake = '',
    vehicleModel = '',
    modelYear = '',
    licensePlate = '',
  } = vehicle || '';

  return (
    <>
      <View style={styles.invoice__date} wrap={false}>
        {id ? (
          <View style={styles.invoice__date__Left}>
            <View style={styles.mr1}>
              <Text style={styles.gray__text_up}>Customer Information</Text>
              <Text style={styles.gray__text}>{name}</Text>
              <Text style={styles.gray__text__down}>{address}</Text>
            </View>

            <View style={styles.mr1}>
              <Text style={styles.gray__text_up}>Contact Information</Text>
              <Text style={styles.gray__text}>{email}</Text>
              <Text style={styles.gray__text__down}>{phone}</Text>

              <Text style={styles.gray__text__down}>
                <Text style={{ fontWeight: 700 }}>PST# </Text>
                {pstNumber}
              </Text>
            </View>

            <View style={styles.mr__l}>
              <Text style={styles.gray__text_up}>Vehicle Information</Text>
              <Text style={styles.gray__text}>
                {modelYear} {vehicleMake} {vehicleModel}
              </Text>
              <Text style={styles.gray__text}>{licensePlate}</Text>
            </View>
          </View>
        ) : (
          <View style={styles.invoice__date__Left}>
            <View style={styles.mr1}>
              <Text style={styles.gray__text_up}>Customer</Text>
              <Text style={styles.gray__text}>Walk-in</Text>
            </View>
          </View>
        )}
      </View>
    </>
  );
}
